"use strict";
/**
 * Get start of current day in UTC.
 * @returns Date timestamp of the current date in UTC at midnight e.g. 2023-05-08T00:00:00.000Z
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartOfCurrentDayUtc = getStartOfCurrentDayUtc;
function getStartOfCurrentDayUtc() {
    const now = new Date();
    const startOfDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0, 0));
    return startOfDay;
}
//# sourceMappingURL=getStartOfCurrentDayUtc.js.map